// BEWARE! This approach will return false if the localStorage quota
// is reached. If you have functions dealing with localStorage cleaning,
// you should edit the catch statement to launch appropriate cleaning
// actions if the exception name e.name ==== 'QUOTA_EXCEEDED_ERR' (Chrome)
// or 'NS_ERROR_DOM_QUOTA_REACHED' (Firefox/Safari) or
// if localStorage.remainingSpace === 0 in IE.

export default function isLocalStorageAvailable() {
  try {
    const test = 'test';

    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch {
    return false;
  }
}
